/**
 * A mapping of link types to matching selectors. Links clicked will be
 * compared against these selectors and assigned a type. These types have
 * been determined based on requirements from event handlers utilizing
 * this decorator ie. DTM and FPS.
 */
const linkTypeSelectors = {
	// probably we can't really change these first ones, many account overrides:
	'ford-parts-page-enrolled': [
		'.alias-commodity-page-parts [data-widget-id="ownership-hero"] a[href*="parts.ford.com/?dealer_id"]'
	],
	'ford-parts-page-not-enrolled': [
		'.alias-commodity-page-parts [data-widget-id="ownership-hero"] a[href="https://parts.ford.com/"]'
	],
	'ford-blue-advantage-search-download-gold': [
		'[data-tracking-label="blue-advantage-gold"]'
	],
	'ford-blue-advantage-search-download-blue': [
		'[data-tracking-label="blue-advantage-blue"]'
	],
	'ford-blue-advantage-search-download-172': [
		'[data-tracking-label="blue-advantage-172"]'
	],
	'ford-blue-advantage-search-download-139': [
		'[data-tracking-label="blue-advantage-139"]'
	],
	// have not found example, seems outdated?
	'fordprotect-page-download-premiumcare-brochure': [
		'[data-tracking-label="premiumcare-brochure"]'
	],
	'fordprotect-page-download-premium-maintenance-brochure': [
		'[data-tracking-label="maintenance-brochure"]'
	],
	// incentive examples in nonprod would be useful:
	incentive: [
		'a[data-incentive-id]',
		'a[href*="/global-incentives/request-form.htm"]',
		'.vehicle-card dl.pricing-detail [role="button"]',
		'.vehicle-card dl.pricing-detail dt .text-link',
		'.vehicle-card .wsm-incentive-display .text-link'
	],
	// Special examples in nonprod would be usful:
	'video-popup': [
		'.hproduct .media .video',
		'#ddc-mobile-vlp-inventory .hproduct .media a[href*="vid"]',
		'#compareForm .hproduct .media .video',
		'.vehicle-card .vehicle-card-media-container .open-media-modal-btn'
	],
	// maybe we should modify ws-inv-listing:
	'windowsticker-vlp': [
		'.srp a[href*="windowsticker"]',
		'.srp a[href*="WindowSticker"]'
	],
	// not finding windowsticker in np:
	'windowsticker-vdp': [
		'.window-sticker-link',
		'.vdp .windowsticker a',
		'.vdpCTA .window-sticker-img-2',
		'.vdp a[href*="windowsticker"]',
		'.vdp a[href*="WindowSticker"]'
	],
	'collision-page-link': [
		'a.collision[href*=".pdf"]',
		'a.collision-link[href="#rights-section"]',
		'a.collision-link[href="#why-choose-section"]'
	],
	// no single place where to modify this one:
	'ford-download': [
		'.ford a[href*=".pdf"]',
		'a[href*="/services/assets/Brochure"]'
	],
	// not true links:
	'slideshow-prev': ['.previousNext a.prev'],
	'slideshow-next': ['.index a.next'],
	'vdp-slideshow': ['.photo-carousel button.btn-carousel.btn'],
	pager: ['.index .pager a'],

	'finance-center': [
		'.alias-sitebuilder-financecenter-1 a[href*="content1-tab-"]',
		'.alias-sitebuilder-financecenter-1 a[href*="content1-panel-"]'
	],
	'black-label-navigator-themekit-learn-more': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links3"] a[href="#navigator"]'
	],
	'black-label-nautilus-themekit-learn-more': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links4"] a[href="#nautilus"]'
	],
	'black-label-aviator-themekit-learn-more': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links2"] a[href="#aviator"]'
	],
	'black-label-navigator-invitation-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow3"] .slideControls a'
	],
	'black-label-navigator-centralpark-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow4"] .slideControls a'
	],
	'black-label-navigator-chalet-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow1"] .slideControls a'
	],
	'black-label-aviator-flight-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow9"] .slideControls a'
	],
	'black-label-aviator-destination-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow5"] .slideControls a'
	],
	'black-label-aviator-chalet-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow8"] .slideControls a'
	],
	'black-label-nautilus-redwood-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow7"] .slideControls a'
	],
	'black-label-nautilus-chalet-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow6"] .slideControls a'
	],
	'black-label-search-inventory-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links1"] a[href*="/new-inventory"]'
	],
	'black-label-search-inventory-click-navigator': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links5"] a[href*="/new-inventory"]'
	],
	'black-label-search-inventory-click-aviator': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links6"] a[href*="/new-inventory"]'
	],
	'black-label-search-inventory-click-nautilus': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links7"] a[href*="/new-inventory"]'
	],
	/* FORD OR LINCOLN */
	'blog-post-tag': ['.alias-blog-post-detail .blog-tag-cloud > a'],
	'blog-list-tag': ['.blog-tag-cloud > a'],
	'coupon-scroll-battery': [
		'.alias-commodity-page-battery button.slick-arrow'
	],
	'coupon-scroll-brakes': ['.alias-commodity-page-brakes button.slick-arrow'],
	'coupon-scroll-tires': ['.alias-commodity-page-tires button.slick-arrow'],
	'print-battery': ['.alias-commodity-page-battery a.print-coupon'],
	'print-brakes': ['.alias-commodity-page-brakes a.print-coupon'],
	'print-tires': ['.alias-commodity-page-tires a.print-coupon'],
	'schedule-battery': [
		'.alias-commodity-page-battery a[href*="/service-appointment.htm"]'
	],
	'schedule-brakes': [
		'.alias-commodity-page-brakes a[href*="/service-appointment.htm"]'
	],
	'schedule-general': [
		'.alias-commodity-page-general-service a[href*="/service-appointment.htm"]',
		'.alias-commodity-page-service a[href*="/service-appointment.htm"]'
	],
	'schedule-oil': [
		'.alias-commodity-page-oil a[href*="/service-appointment.htm"]'
	],
	'schedule-tires': [
		'.alias-commodity-page-tires a[href*="/service-appointment.htm"]'
	],
	'shop-accessories': [
		'.accessories-page a[data-tracking="shop-accessories"]'
	],
	'ford-adchoices': ['a[href*="https://www.forddirect.com/adchoices"]'],
	'ford-pass-learn-about-the-app': [
		'.alias-adops-why-buy-ford-pass .learn-about-fordpass-app',
		'.alias-sitebuilder-fordpass-2022-1 .learn-about-fordpass-app'
	],
	'ford-pass-learn-about-the-rewards': [
		'.alias-adops-why-buy-ford-pass .learn-about-fordpass-rewards',
		'.alias-sitebuilder-fordpass-2022-1 .learn-about-fordpass-rewards'
	],
	'ev-overview-explore-charging': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links3"] .explore-charging'
	],
	'ford-mobile-learn-more': [
		'.alias-sitebuilder-ford-mobile-service-1 .rewards-overview'
	],
	// this one is also at account level:
	'staff-click': ['#staffList a'],
	'finance-application': [
		'.alias-finance-application .finance-application .btn-primary',
		'.alias-finance-application .finance-application a[href*="#finance-application"]',
		'.alias-finance-application .finance-application a[href*="#fordprofile_finance_application"]'
	],
	'payment-calculator': [
		'.vdp .payment-summary .btn',
		'.vdp .payment-calculator-wrapper .btn',
		'.vdp .ws-detailed-pricing .btn'
	],
	'ford-pass-apple-app-top': [
		'.alias-adops-why-buy-ford-pass .app-link a[href*="apps.apple.com"]',
		'.alias-commodity-page-ford-pass .app-link a[href*="apps.apple.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(-n+4) a[href*="apps.apple.com"]'
	],
	'ford-pass-android-app-top': [
		'.alias-adops-why-buy-ford-pass .app-link a[href*="play.google.com"]',
		'.alias-commodity-page-ford-pass .app-link a[href*="play.google.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(-n+4) a[href*="play.google.com"]'
	],
	'ford-pass-android-app-bottom': [
		'.alias-adops-why-buy-ford-pass .app-rewards a[href*="play.google.com"]',
		'.alias-commodity-page-ford-pass .app-rewards a[href*="play.google.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(n+5) a[href*="play.google.com"]'
	],
	'lincoln-cpo-overview-general-click': [
		'.lincoln.alias-certified-pre-owned-vehicles .links-list .wb-btn',
		'.lincoln.alias-certified-pre-owned-vehicles .links-list .btn-primary',
		'.lincoln.alias-certified-pre-owned-vehicles .links-list .text-capitalize:not([data-link-label="DOWNLOAD_200_POINT_INSPECTION"])'
	],
	'lincoln-competitve-compare-corsair-more': [
		'[data-tracking-label="comparison-corsair-more-about"]'
	],
	'lincoln-competitve-compare-aviator-search': [
		'.alias-competitive-comparison [data-widget-id="hero1"] .btn-primary',
		'.alias-competitive-comparison [data-widget-id="links1"] a[href*="inventory"]'
	],
	'ford-mobile-service': [
		'.alias-sitebuilder-ford-mobile-service-1 .schedule-service a'
	],
	schedule_delivery_1: [
		'.alias-sitebuilder-ford-pickup-and-delivery-1 [href*="/service-appointment.htm"]'
	],
	accordion_delivery_1: [
		'.alias-sitebuilder-ford-pickup-and-delivery-1 [data-widget-id*="accordion-content1"] a'
	],
	'model-e-buy-now-srp': [
		'.srp [data-web-api-id="forddirect-add-model-e-cta-to-vdp"] .btn'
	],
	'model-e-buy-now-vdp': [
		'.vdp [data-web-api-id="forddirect-add-model-e-cta-to-vdp"] .btn'
	],
	'pickup-and-delivery-cta': [
		'.alias-pickup-and-delivery .btn[data-form-id="service1"]'
	],

	// KEEP AT BOTTOM
	referral: [
		'a[href*="ford.com"]',
		'a[href*="lincoln.com"]',
		'a[href*="forddirect.com"]',
		'a[href*="forddirectprivacy.com"]'
	]
};

export default linkTypeSelectors;
